module.exports = __webpack_public_path__ + "img/five-2.ff472d4b.png";